"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cartRef,
    isVisible: cartVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const summaryTeaser = [{
    label: "PIECES",
    value: "—"
  }, {
    label: "SUBTOTAL",
    value: "—"
  }, {
    label: "DELIVERY",
    value: "Calculated at checkout"
  }];
  return <section data-section-id="2026" id="cart-content" className="bg-background text-foreground py-24 md:py-36 font-default">
      <div className="mx-auto w-full max-w-[1440px] px-6 md:px-12">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-10 mb-16 md:mb-24 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="md:col-span-7">
            <div className="font-mono uppercase mb-8 md:mb-10" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.18em",
            color: "var(--muted-foreground)"
          }}>
              § — YOUR SELECTION
            </div>

            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2.25rem, 4.8vw, 4.5rem)",
            fontWeight: 300,
            letterSpacing: "-0.025em",
            lineHeight: 1.02
          }}>
              Refine your
              <br />
              <em className="font-default" style={{
              color: "var(--primary)",
              fontStyle: "italic",
              fontWeight: 300
            }}>
                curated
              </em>
              <br />
              essence
            </h2>
          </div>

          {}
          <div className="md:col-span-5 md:pl-8 md:border-l md:border-border/60 flex md:items-end">
            <div className="w-full">
              <div className="font-mono uppercase mb-6" style={{
              fontSize: "0.6875rem",
              letterSpacing: "0.18em",
              color: "var(--muted-foreground)"
            }}>
                § — ORDER SUMMARY
              </div>

              <ul className="space-y-3">
                {summaryTeaser.map((row, i) => <li data-index={i} key={row.label} className="flex items-baseline justify-between font-mono" style={{
                fontSize: "0.8125rem",
                letterSpacing: "0.08em"
              }}>
                    <span style={{
                  color: "var(--muted-foreground)"
                }}>{row.label}</span>
                    <span className="flex-1 mx-3 border-b border-dotted" style={{
                  borderColor: "var(--border)"
                }} aria-hidden="true" />
                    <span style={{
                  color: "var(--foreground)"
                }}>{row.value}</span>
                  </li>)}
              </ul>

              <div className="mt-6 flex items-center gap-2">
                <span className="block flex-1 h-px" style={{
                background: "var(--border)"
              }} aria-hidden="true" />
                <span className="inline-block w-[7px] h-[7px] rounded-lg" style={{
                background: "var(--primary)"
              }} aria-hidden="true" />
              </div>

              <p className="mt-4 font-default italic" style={{
              fontSize: "0.9375rem",
              color: "var(--muted-foreground)",
              lineHeight: 1.5
            }}>
                Totals adjust automatically as you modify your collection.
              </p>
            </div>
          </div>
        </div>

        {}
        <div ref={cartRef} className={`relative transition-all duration-700 ease-out ${cartVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <span aria-hidden="true" className="absolute -top-3 -left-3 w-4 h-4 pointer-events-none" style={{
          backgroundImage: "linear-gradient(var(--border), var(--border)), linear-gradient(var(--border), var(--border))",
          backgroundSize: "100% 1px, 1px 100%",
          backgroundPosition: "center, center",
          backgroundRepeat: "no-repeat"
        }} />
          <span aria-hidden="true" className="absolute -top-3 -right-3 w-4 h-4 pointer-events-none" style={{
          backgroundImage: "linear-gradient(var(--border), var(--border)), linear-gradient(var(--border), var(--border))",
          backgroundSize: "100% 1px, 1px 100%",
          backgroundPosition: "center, center",
          backgroundRepeat: "no-repeat"
        }} />
          <span aria-hidden="true" className="absolute -bottom-3 -left-3 w-4 h-4 pointer-events-none" style={{
          backgroundImage: "linear-gradient(var(--border), var(--border)), linear-gradient(var(--border), var(--border))",
          backgroundSize: "100% 1px, 1px 100%",
          backgroundPosition: "center, center",
          backgroundRepeat: "no-repeat"
        }} />
          <span aria-hidden="true" className="absolute -bottom-3 -right-3 w-4 h-4 pointer-events-none" style={{
          backgroundImage: "linear-gradient(var(--border), var(--border)), linear-gradient(var(--border), var(--border))",
          backgroundSize: "100% 1px, 1px 100%",
          backgroundPosition: "center, center",
          backgroundRepeat: "no-repeat"
        }} />

          {}
          <div className="bg-card/40 border border-border/60 p-6 md:p-10">
            <WooCommerceCartBlock />
          </div>

          {}
          <div className="mt-10 flex items-center gap-2">
            <span className="block flex-1 h-px" style={{
            background: "var(--border)"
          }} aria-hidden="true" />
            <span className="inline-block w-[7px] h-[7px] rounded-lg" style={{
            background: "var(--primary)"
          }} aria-hidden="true" />
          </div>

          <div className="mt-4 font-mono uppercase flex items-center justify-between" style={{
          fontSize: "0.6875rem",
          letterSpacing: "0.18em",
          color: "var(--muted-foreground)"
        }}>
            <span>§ — SECURE TRANSACTION</span>
            <span>ESSENCE & CO. · PARIS</span>
          </div>
        </div>
      </div>
    </section>;
}